import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/Routes"; // Import routes

function App() {
  return (
    <Router>
      <AppRoutes />  {/* Render all routes */}
    </Router>
  );
}

export default App;